import { render, staticRenderFns } from "./CreateIcon.vue?vue&type=template&id=c742926a"
import script from "./CreateIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c742926a')) {
      api.createRecord('c742926a', component.options)
    } else {
      api.reload('c742926a', component.options)
    }
    module.hot.accept("./CreateIcon.vue?vue&type=template&id=c742926a", function () {
      api.rerender('c742926a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/CreateIcon.vue"
export default component.exports